const fitImageInsideContainer = ($image: HTMLElement, $container: HTMLElement) => {
  const { width: containerWidth, height: containerHeight } = $container.getBoundingClientRect();
  const $img = $image instanceof HTMLImageElement ? $image : $image.querySelector('img');
  const { width, height } = $img ?? {};

  if (width && height) {
    const imageRatio = width / height;
    const fittedRatio = containerHeight / (containerWidth / imageRatio);
    const maxWidth = Math.min(1, fittedRatio) * 100;

    $image.style.maxWidth = `${maxWidth}%`;
  }
};

export default fitImageInsideContainer;
